export const FreeSpinsAnimation = {
    'EN': {
        BUY_FREESPIN_APPEAR: 'buyfreespins_appear',
        BUY_FREESPIN_DISAPPEAR: 'buyfreespins_disappear',
        BUY_FREESPIN_LOOP: 'buyfreespins_loop',

        FREESPIN_APPEAR: 'freespin_appear',
        FREESPIN_APPEAR_MOBILE: 'freespin_appear_mobile',
        FREESPIN_DISAPPEAR: 'freespin_disappear',
        FREESPIN_DISAPPEAR_MOBILE: 'freespin_disappear_mobile',
        FREESPIN_LOOP: 'freespin_loop',
        FREESPIN_LOOP_MOBILE: 'freespin_loop_mobile',

        IN15FREESPIN_APPEAR: 'in15freespin_appear',
        IN15FREESPIN_APPEAR_MOBILE: 'in15freespin_appear_mobile',
        IN15FREESPIN_DISAPPEAR: 'in15freespin_disappear',
        IN15FREESPIN_DISAPPEAR_MOBILE: 'in15freespin_disappear_mobile',
        IN15FREESPIN_LOOP: 'in15freespin_loop',
        IN15FREESPIN_LOOP_MOBILE: 'in15freespin_loop_mobile',
    },
    'TR': {
        BUY_FREESPIN_APPEAR: 'buyfreespins_appear',
        BUY_FREESPIN_DISAPPEAR: 'buyfreespins_disappear',
        BUY_FREESPIN_LOOP: 'buyfreespins_loop',

        FREESPIN_APPEAR: 'freespin_appear_turkish',
        FREESPIN_APPEAR_MOBILE: 'freespin_appear_mobile_turkish',
        FREESPIN_DISAPPEAR: 'freespin_disappear_turkish',
        FREESPIN_DISAPPEAR_MOBILE: 'freespin_disappear_mobile_turkish',
        FREESPIN_LOOP: 'freespin_loop_turkish',
        FREESPIN_LOOP_MOBILE: 'freespin_loop_mobile_turkish',

        IN15FREESPIN_APPEAR: 'in15freespin_appear_turkish',
        IN15FREESPIN_APPEAR_MOBILE: 'in15freespin_appear_mobile_turkish',
        IN15FREESPIN_DISAPPEAR: 'in15freespin_disappear_turkish',
        IN15FREESPIN_DISAPPEAR_MOBILE: 'in15freespin_disappear_mobile_turkish',
        IN15FREESPIN_LOOP: 'in15freespin_loop_turkish',
        IN15FREESPIN_LOOP_MOBILE: 'in15freespin_loop_mobile_turkish',
    }
}
